import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 py-4">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-center justify-between text-white">
          {/* Left Side - Copyright */}
          <div className="text-sm">
            © {new Date().getFullYear()} SSVK Chokkady, All Rights Reserved.
          </div>

          {/* Right Side - Links */}
          <nav>
            <ul className="flex space-x-4 text-sm">
              <li>
                <a href="https://goo.gl/maps/DJjPhpq9nfFS6UWY6" target="_blank" rel="noopener noreferrer" className="hover:underline">
                  Our Location
                </a>
              </li>
              <li>
                <a href="https://www.ssvkchokkady.org/terms" className="hover:underline">
                  Terms &amp; Conditions
                </a>
              </li>
              <li>
                <a href="#" className="hover:underline">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="hover:underline">
                  Cookies
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
